import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../constants/axiosInstance';
import { useState, useCallback } from 'react';
import { useSignedInUser } from '../../../session';
import { trackEvent } from '../../../modules/analytics/trackingMiddleware';
import { COMMUNICATION_OPENED } from '../../../modules/analytics/events';

const fetchCommunicationCount = async (): Promise<number> => {
  const { data } = await axiosInstance().get('communication/getCommunicationCount');
  return typeof data?.data?.count === 'number' ? data.data.count : 0;
};

export const useCommunicationCount = () => {
  const { id: userId } = useSignedInUser();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    trackEvent(COMMUNICATION_OPENED, { source: 'communication_bell' });
  }, []);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);
  const isModalOpen = Boolean(anchorEl);

  const {
    data: count = 0,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['communicationCount', userId],
    queryFn: fetchCommunicationCount,
    staleTime: 60 * 1000,
  });

  return {
    count,
    isLoading,
    error,
    refetch,
    anchorEl,
    handleClick,
    handleClose,
    isModalOpen,
  };
}; 